import { Keyboard, Platform } from 'react-native';

/**
 * Dismiss the soft keyboard, blurring whichever input currently holds focus.
 *
 * No-op on web: there is no soft keyboard to collapse, and the builder renders
 * the app preview alongside its own focused inputs, so stealing focus there
 * would be a regression rather than a fix.
 */
export const dismissKeyboard = () => {
  if (Platform.OS === 'web') {
    return;
  }
  Keyboard.dismiss();
};
